<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :items="grupos"
      :loading="loading"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-spacer />
          <v-btn
            v-if="perms.includes('subgrupo.criar_subgrupo')"
            depressed
            color="accent"
            :to="{ name: 'sub-grupo-item-formulario' }"
          >
            <v-icon class="mdi mdi-plus mr-2" />Novo Cadastro
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          v-if="perms.includes('subgrupo.editar_subgrupo')"
          icon
          small
          text
          @click="editar(item.id)"
        >
          <v-icon class="mdi mdi-pencil" small />
        </v-btn>
        <dialog-confirm
          v-if="perms.includes('subgrupo.excluir_subgrupo')"
          titulo="Deletar Sub-Grupo Item"
          texto="Confirma a exclusão?"
          @confirmar="deletar(item.id)"
        >
          <v-btn icon small text>
            <v-icon class="mdi mdi-delete" small />
          </v-btn>
        </dialog-confirm>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import DialogConfirm from "../components/DialogConfirm";
export default {
  components: { DialogConfirm },
  data() {
    return {
      headers: [
        { text: "Código", value: "codigo" },
        { text: "Descrição", value: "descricao" },
        { text: "Grupo Item", value: "id_grupoitem" },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
      loading: false,
      dialogConfirm: false,
    };
  },
  computed: {
    grupos() {
      return this.$store.state.subGrupoItem.subGrupoItem;
    },
    perms() {
      return this.$store.state.usuarios.usuarioAtivo.permissoes;
    },
  },
  methods: {
    async listar() {
      this.loading = true;
      try {
        await this.$store.dispatch("subGrupoItem/listar");
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível carregar a lista de sub-grupos de item",
        });
      }
      this.loading = false;
    },
    async deletar(id) {
      this.loading = true;
      await this.$store.dispatch("subGrupoItem/deletar", { id });
      this.listar();
    },
    editar(id) {
      this.$router.replace({
        name: "sub-grupo-item-formulario-editar",
        params: { id },
      });
    },
  },
  mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Cadastro de sub-grupos de item",
    });
    this.listar();
  },
};
</script>
